import React, { useState } from "react";
import { useTranslation } from "@lib/i18n";

import FooterFAQ from "./FooterFAQ";
import Perks from "../Journey/Perks";

import gtm from "@gtm/core";
import { faqSectionDisplayEvent } from "@gtm/events/shared";

const FooterSection = () => {
  const { t } = useTranslation();
  const [openSections, setOpenSections] = useState([]);

  const checkIsSectionOpen = sectionName => openSections.includes(sectionName);

  const onClick = sectionName => {
    if (!checkIsSectionOpen(sectionName)) {
      setOpenSections([sectionName, ...openSections]);
      gtm.fire(faqSectionDisplayEvent(t(sectionName)));
      return;
    }
    setOpenSections(
      openSections.filter(
        openedSectionName => openedSectionName !== sectionName
      )
    );
  };

  const content = t("footer.faq.sections", { returnObjects: true });

  return (
    <>
      <div className="py-4 bg-primaryDark" data-id={"faq-component"}>
        <FooterFAQ
          label={"footer.sections.faq.label"}
          description={"footer.sections.faq.content"}
          onClick={onClick}
          isOpen={checkIsSectionOpen("footer.sections.faq.label")}
          content={Object.keys(content)}
          isLast
        />
      </div>
      <Perks />
    </>
  );
};

export default FooterSection;
